<template>
  <div>
    <Rate
      v-model="value"
      @change="rateChange"
      :allow-half="allowHalf"
      :disabled="disabled"
      show-score
      :score-template="`${score.toFixed(1)}`"
    ></Rate>
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Rate, Notification } from "element-ui";

export default {
  components: {
    Rate
  },
  props: {
    taskId: {
      type: Number,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    allowHalf: {
      type: Boolean,
      default: () => false
    },
    score: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      value: 0
    };
  },
  mounted() {
    this.value = this.score;
  },
  methods: {
    rateChange(e) {
      //console.log(e);
      if (!this.disabled) {
        request({
          api: { method: "post", url: "Task/Rate" },
          data: { taskId: this.taskId, rate: e },
          store: this.$store
        }).then(res => {
          if (res != false) {
            Notification.success({
              message: "Үнэлгээ өгсөнд баярлалаа.",
              duration: 5000,
              type: "info",
              position: "top-right",
              offset: 50
            });
            this.$emit("on-rated", this.value);
            //this.$emit('on-rate', {rate: e, avg: res.data.rateAvg});
          }
        });
      }
    }
  }
};
</script>

<style></style>
